export const wsConfig = {
    encryption: true,
    host: 'ws.vega-mx.com',
    port: 443,
};
